// Abilities (special actions) — shown inside their area in the access grid.
// mode="preset": value = Set of keys. mode="user": value = {key: true|false} overrides, effective = Set.
import { useEffect, useState } from "react";
import api from "../../lib/api";

let catalog = null;
export function useCapabilityCatalog() {
  const [caps, setCaps] = useState(catalog || []);
  useEffect(() => {
    if (catalog) return;
    api.get("/access/capabilities").then(({ data }) => { catalog = data.capabilities || []; setCaps(catalog); }).catch(() => {});
  }, []);
  return caps;
}

const seg = (on) => `px-2 py-1 text-[10.5px] font-medium border transition-colors ${on ? "bg-orange-500/15 border-orange-400/50 text-orange-200" : "border-white/10 text-slate-400 hover:text-white"}`;

export default function AbilitiesEditor({ mode, value, effective, onChange, area, testid = "abilities" }) {
  const caps = useCapabilityCatalog().filter((c) => !area || c.area === area);
  if (!caps.length) return null;
  return (
    <div className="pl-9 pr-3 py-2 bg-white/[0.015]" data-testid={testid}>
      <div className="text-[9.5px] uppercase tracking-widest text-slate-500 font-mono mb-1.5">Special actions</div>
      <div className="space-y-1.5">
        {caps.map((c) => {
          if (mode === "preset") {
            const on = value.has(c.key);
            return (
              <label key={c.key} className="flex items-center justify-between gap-3 text-[12.5px] text-slate-200 cursor-pointer" data-testid={`${testid}-${c.key}`}>
                <span>{c.label}</span>
                <input type="checkbox" checked={on} onChange={(e) => {
                  const n = new Set(value); e.target.checked ? n.add(c.key) : n.delete(c.key); onChange(n);
                }} className="accent-orange-500" data-testid={`${testid}-${c.key}-toggle`} />
              </label>
            );
          }
          const ov = value[c.key];
          const set = (v) => { const n = { ...value }; if (v === undefined) delete n[c.key]; else n[c.key] = v; onChange(n); };
          return (
            <div key={c.key} className="flex items-center justify-between gap-3" data-testid={`${testid}-${c.key}`}>
              <span className="text-[12.5px] text-slate-200 min-w-0 flex-1">
                {c.label}
                <span className={`ml-2 text-[10px] font-mono ${effective?.has(c.key) ? "text-emerald-300" : "text-slate-500"}`}>{effective?.has(c.key) ? "ON" : "OFF"}</span>
                {ov !== undefined && <span className="ml-1 text-[9px] font-mono uppercase tracking-widest text-fuchsia-300">custom</span>}
              </span>
              <span className="inline-flex shrink-0 rounded-md overflow-hidden">
                <button type="button" className={`${seg(ov === undefined)} rounded-l-md`} onClick={() => set(undefined)} data-testid={`${testid}-${c.key}-default`}>Preset</button>
                <button type="button" className={seg(ov === true)} onClick={() => set(true)} data-testid={`${testid}-${c.key}-on`}>On</button>
                <button type="button" className={`${seg(ov === false)} rounded-r-md`} onClick={() => set(false)} data-testid={`${testid}-${c.key}-off`}>Off</button>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
